{
  "pipeData": {
    "get.customer.details": {
      "data": [
        {
          "id": 5433,
          "calculatedName": "Marko Milakovic",
          "accountNo": "MM6NAKF5F9",
          "iban": "DE821209659700000038XX",
          "sepaMandateDate": "17.05.2019",
          "sepaStopDate": "01.10.2025",
          "balance": -396.26,
          "lastUpdated": "2025-12-16T10:24:00"
        }
      ]
    },

    "get.previous.accounts": {
      "data": [
        {
          "customerName": "Marko Milakovic",
          "accountNo": "MM6NAKF5F9",
          "role": "Selbstzahler",
          "iban": "DE821209659700000038XX",
          "fromDate": "01.01.2021",
          "toDate": "01.01.2023",
          "type": "CUSTOMER"
        },
        {
          "customerName": "Hausratversicherung",
          "accountNo": "24596768",
          "role": "Self-payer",
          "iban": "—",
          "fromDate": "01.01.2020",
          "toDate": "01.01.2022",
          "type": "INSURANCE"
        }
      ]
    },

    "get.billing.account.transaction": {
      "data": [
        {
          "date": "01.07.2025",
          "description": "Beitrag: SEPA gescheitert",
          "debitAccount": "DE821209659700000038XX",
          "debit": 49.26,
          "credit": null,
          "targetAccount": "DE05513800400936205800",
          "balance": -49.26
        },
        {
          "date": "03.12.2025",
          "description": "RA - Lawyer",
          "debitAccount": "Überweisung",
          "debit": 80,
          "credit": null,
          "targetAccount": "DE732005000000XXXX999",
          "balance": -396.26
        }
      ]
    },

    "get.mahnung.summary": {
      "data": [
        { "label": "Rückstand", "hint": "3 Monate", "value": 148.49 },
        { "label": "WIK", "hint": "6 Monate", "value": 394.08 },
        { "label": "BLR", "value": 20.7 },
        { "label": "RA Lawyer", "value": 80 }
      ]
    },

    "get.contract.detail": {
      "data": [
        {
          "contractName": "Unfallrente",
          "contractNo": "80786906",
          "provider": "Nürnberger Rathi",
          "premium": 37.22,
          "rows": [
            { "label": "Rückstand", "value": 111.66 },
            { "label": "WIK", "hint": "reactivate", "value": 297.76 }
          ]
        }
      ]
    }
  }
}